// initial state
// shape: [{ id, description, additional, price, side, category, subcategory, quantity }]
function initialState() {
	return {
		items: [],
		override: null,
		restoringJob: false
	}
}
const state = initialState()

// getters
const getters = {
	cartProducts: (state) => {
		return state.items;
	},
	cartCount: (state) => {
		return state.items.length;
	},
	cartTotalPrice: (state, getters) => {
		return getters.cartProducts.reduce((total, product) => {
			return total + product.Price * product.Quantity
		}, 0)
	},
	cartTotalDiscountedPrice: (state, getters) => {
		
		// TODO: rewrite this to accept currency value discounts as well as percentage
		
		return getters.cartProducts.reduce((total, product) => {
			if (product.DiscountType == 'percent') {
				return total + Math.round(((1-(product.DiscountValue/100)) * product.Price)) * product.Quantity
			} else {
				return total + (product.Price-product.DiscountValue) * product.Quantity;
			}
		}, 0)
	},
	overrideTotalPrice: (state) => {
		return typeof state.override !== 'undefined' ? state.override : 0
	},
	overrideSet: (state) => {
		return state.override !== null ? true : false
	},
	leadTimeTotal: (state) => {
		/* get highest lead time of lenses, add to cumulative lead time of addons */
		var lensTime = 0;
		var addonTime = 0;
		var uniqueIDs = []
		state.items.forEach((item) => {
			if (item.Category == 'Lens' && item.LeadTime > lensTime) {
				lensTime = item.LeadTime
			}
			if (!uniqueIDs.includes(item.Product) && item.Category == 'Addon'){
				uniqueIDs.push(item.Product)
				addonTime += +item.LeadTime
			}
		})
		return lensTime+addonTime
	},
	frameCount: (state, getters, rootState, rootGetters) => {
		let focusFrames = state.items.reduce((accumulator, object) => (object.Category === 'Frame') ? accumulator+object.Quantity : accumulator, 0);
		let cxFrame = rootGetters.cxFrameType ? 1 : 0;
		return focusFrames+cxFrame;
	},
	lensCount: (state) => {
		return state.items.reduce((accumulator, object) => (object.Category === 'Lens') ? accumulator+object.Quantity : accumulator, 0);
	},
	rightLensCount: (state) => {
		return state.items.reduce((accumulator, object) => (object.Category === 'Lens' && object.Side === 'R') ? accumulator+object.Quantity : accumulator, 0)
	},
	leftLensCount: (state) => {
		return state.items.reduce((accumulator, object) => (object.Category === 'Lens' && object.Side === 'L') ? accumulator+object.Quantity : accumulator, 0)
	},
	frameAndLensCount: (state, getters) => {
		return getters.frameCount+getters.lensCount;
	},
	glazingCount: (state, getters) => {
		return state.items.reduce((accumulator, object) => (object.Category === 'Glazing') ? accumulator+object.Quantity : accumulator, 0);
	},
	glazingInCart: (state,) => (side) => {
		return state.items.find(item => (item.Category == 'Glazing' && item.Side == side))
	},
	glazingPossible: (state, getters, rootState, rootGetters) => {
		// Discern glazing eligibility - need exactly one frame, one or two lenses, if two then can't be on the same side
		let glazingEligibility = (getters.lensCount < 3 && getters.lensCount > 0 && getters.rightLensCount < 2 && getters.leftLensCount < 2 && getters.frameCount == 1) ? true : false;

		if (glazingEligibility) {
			let focusFrame = state.items.find(item => (item.Category === 'Frame'));
			let frameType = focusFrame ? focusFrame.SubCategory : rootGetters.cxFrameType;
			let lensParameters = state.items.reduce((lenses, item) => {
				if (item.Category === 'Lens') {
					let lens = {
						'Side': item.Side,
						'Quantity': item.Quantity,
						'Classification': item.Additional.Classification,
						'SubCategory': item.SubCategory,
						'FilterType': item.Additional.FilterType,
						'AddMax': item.Additional.AddMax,
						'AddMin': item.Additional.AddMin,
						'CylinderMax': item.Additional.CylinderMax,
						'DiameterMax': item.Additional.DiameterMax,
						'HeightMin': item.Additional.HeightMin,
						'SphereMax': item.Additional.SphereMax,
						'SphereMin': item.Additional.SphereMin
					}
					lenses.push(lens)
				}
				return lenses
			}, []);
			return { glazingEligibility, frameType, lensParameters }
		} else {
			return { glazingEligibility }
		}
	}
}

// actions
const actions = {
	restoreState ({ state, commit }, restoring) {
		commit('setRestoreState', restoring)
	},
	resetState ({ state, commit }) {
		commit('reset')
	},
	addProductToCart ({ state, commit, rootGetters }, product) {
		return new Promise((resolve, reject) => {
			// If there isn't already an item in the cart that has the same product ID and side assigned, add it, else increment the existing
			// Left and right additions aren't coalesced to a pair to avoid complicated handling across different product types that have different requirements
			const cartItem = state.items.find(item => (item.Product === product.Product) && (item.Side === product.Side))
			// ***** CONFLICT HANDLING *****

			// Handle frame conflicts - multiples only allowed for Focus supplied frames
			const cxFrameItem = state.items.find(item => (item.Category == 'CX frame'))
			const focusFrameItem = state.items.find(item => (item.Category == 'Frame'))

			// Count the number of Focus stock frames currently in the store - adding quantities across models
			let frameMultiples = state.items.reduce((accumulator, object) => (object.Category === 'Frame' || object.Category === 'CX frame') ? accumulator+object.Quantity : accumulator, 0)
			// Count the number of lenses
			let lensMultiples = state.items.reduce((accumulator, object) => object.Category === 'Lens' ? accumulator+object.Quantity : accumulator, 0)
			// Count the number of right lenses
			let rightLensCount = state.items.reduce((accumulator, object) => (object.Category === 'Lens' && object.Side === 'R') ? accumulator+object.Quantity : accumulator, 0)
			// Count the number of left lenses
			let leftLensCount = state.items.reduce((accumulator, object) => (object.Category === 'Lens' && object.Side === 'L') ? accumulator+object.Quantity : accumulator, 0)

			let lensMultipleFrameConflict = false
			// Trying to add lenses when there's more than one frame
			if (product.Category == 'Lens' && frameMultiples > 1) {
				lensMultipleFrameConflict = true
			}
			// Trying to add a frame when there's already frames and lenses
			if (product.Category == 'Frame' && lensMultiples > 0 && frameMultiples > 0) {
				lensMultipleFrameConflict = true
			}
			// Trying to add a frame when there's more than 2 lenses
			if ((product.Category == 'Frame' || product.Category == 'CX frame') && lensMultiples > 2) {
				lensMultipleFrameConflict = true
			}
			// Trying to add lenses when there's already a frame and 2 lenses
			if (product.Category == 'Lens' && frameMultiples > 0 && lensMultiples > 1) {
				lensMultipleFrameConflict = true
			}
			// Trying to add a frame when there's more than 1 right lens or more than 1 left lens
			if ((product.Category == 'Frame' || product.Category == 'CX frame') && (rightLensCount > 1 || leftLensCount > 1)){
				lensMultipleFrameConflict = true
			}
			// Trying to make one side lens count > 1 when there's a frame
			if (product.Category == 'Lens' && product.Side == 'R' && rightLensCount > 0 && frameMultiples > 0) {
				lensMultipleFrameConflict = true
			}
			if (product.Category == 'Lens' && product.Side == 'L' && leftLensCount > 0 && frameMultiples > 0) {
				lensMultipleFrameConflict = true
			}
			if (product.Category == 'Lens' && product.Side == 'P' && (leftLensCount > 0 || rightLensCount > 0) && frameMultiples > 0) {
				lensMultipleFrameConflict = true
			}

			let frameConflict = false
			if (product.Category == 'CX frame' && (cxFrameItem || focusFrameItem)) {
				frameConflict = true
			}
			if (product.Category == 'Frame' && cxFrameItem) {
				frameConflict = true
			}

			// ***** ADD/REJECT CART CHANGES *****
			if (frameConflict) {
				reject('Multiple frames only allowed if they are all from Focus stock. Please process reglazes as a separate order.')
			} else if (lensMultipleFrameConflict) {
				reject('Multiple frames and lenses on a single order are not compatible. Glazed pairs should be processed individually.')
			} else {
				if (!cartItem) {
					// Get base account discount
					var accountDiscount = rootGetters.discount
					// Get list of eligible categories/subcategories
					var lineItemDiscounts = rootGetters.lineItemDiscounts
					// Set discount amount and type for this item
					var thisItemDiscountValue = 0;
					var thisItemDiscountType = 'percent';
					
					if (product.SpecialDiscountValue) { // Lenses
						thisItemDiscountValue = product.SpecialDiscountValue;
						thisItemDiscountType = product.SpecialDiscountType;
					} else {
						if (product.DiscountExempt) { // Addons
							if (product.DiscountExempt == 'N') {
								// Apply Focus discount - in case of no brand, assume Focus (only for addons)
								product.Brand = !product.Brand ? 'Focus' : product.Brand;
								if (product.Brand == 'Focus' && (lineItemDiscounts.includes(product.Category) || lineItemDiscounts.includes(product.SubCategory))) {
									thisItemDiscountValue = accountDiscount;
								}
							} // Else do nothing, discount was previously set to 0
						} else { // Other
							// Check if this product's (sub)category is in the eligible list and it's a Focus lens, if so then apply standard account level discount
							if (product.Brand == 'Focus' && (lineItemDiscounts.includes(product.Category) || lineItemDiscounts.includes(product.SubCategory))) {
								thisItemDiscountValue = accountDiscount;								
							}
						}
					}
					commit('pushProductToCart', { Product: product.Product, Description: product.Description, Brand: product.Brand, Additional: product.Additional, Price: product.Price, Cost: product.Cost, DiscountValue: thisItemDiscountValue, DiscountType: thisItemDiscountType, Side: product.Side, Category: product.Category, SubCategory: product.SubCategory, LeadTime: product.LeadTime, ValidFrom: product.ValidFrom })
					resolve()
				} else {
					commit('incrementItemQuantity', cartItem.Product)
					resolve()
				}
			}
		})
	},
	// Restore products from job loaded from database to the cart
	restoreProductToCart ({ state, commit, rootGetters }, product ) {
		return new Promise((resolve, reject) => {
			const cartItem = state.items.find(item => (item.Product === product.Product) && (item.Side === product.Side))
			if (!cartItem) {
				// Get base account discount
				var accountDiscount = rootGetters.discount
				// Get list of eligible categories/subcategories
				var lineItemDiscounts = rootGetters.lineItemDiscounts
				// Set discount amount and type for this item
				var thisItemDiscountValue = 0;
				var thisItemDiscountType = 'percent';
				if (product.SpecialDiscountValue) { // Lenses
					thisItemDiscountValue = product.SpecialDiscountValue;
					thisItemDiscountType = product.SpecialDiscountType;
				} else {
					if (product.DiscountExempt) { // Addons
						if (product.DiscountExempt == 'N') {
							// Apply Focus discount - in case of no brand, assume Focus (only for addons)
							product.Brand = !product.Brand ? 'Focus' : product.Brand;
							if (product.Brand == 'Focus' && (lineItemDiscounts.includes(product.Category) || lineItemDiscounts.includes(product.SubCategory))) {
								thisItemDiscountValue = accountDiscount;
							}
						} // Else do nothing, discount was previously set to 0
					} else { // Other
						// Check if this product's (sub)category is in the eligible list and it's a Focus lens, if so then apply standard account level discount
						if (product.Brand == 'Focus' && (lineItemDiscounts.includes(product.Category) || lineItemDiscounts.includes(product.SubCategory))) {
							thisItemDiscountValue = accountDiscount;								
						}
					}
				}
				commit('pushProductToCart', { Product: product.Product, Description: product.Description, Brand: product.Brand, Additional: product.Additional, Price: product.Price, Cost: product.Cost, DiscountValue: thisItemDiscountValue, DiscountType: thisItemDiscountType, Side: product.Side, Category: product.Category, SubCategory: product.SubCategory, LeadTime: product.LeadTime, ValidFrom: product.ValidFrom, Quantity: product.Quantity })
				resolve()
			} else {
				commit('incrementItemQuantity', cartItem.Product)
				resolve()
			}
		})
	},
	removeProductFromCart ({ state, commit }, lineItemID) {
		commit('pullProductFromCart', lineItemID)
	},
	removeGlazing ({ state, commit }) {
		const glazingIndex = state.items.findIndex(item => item.Category === "Glazing")
		if (glazingIndex >= 0) { // glazingIndex is -1 if not found which for some reason passes this check?! WTF JS?!
			commit('pullProductFromCart', glazingIndex);
		}
	},
	addOverrideTotal ({ state, commit }, value) {
		commit('setOverrideTotal', value)
	},
	// For use when restoring an override total from DB (no point converting int to currency and back again!)
	addOverrideTotalInteger ({ state, commit }, value) {
		commit('setOverrideTotalInteger', value)
	},
	removeOverrideTotal ({ state, commit }, value) {
		commit('unsetOverrideTotal')
	}
}

// mutations
const mutations = {
	setRestoreState (state, restoring) {
		state.restoringJob = restoring
	},
	reset (state) {
		// acquire initial state
		const s = initialState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	},
	pushProductToCart (state, { Product, Description, Brand, Additional, Price, Cost, DiscountValue, DiscountType, Side, Category, SubCategory, LeadTime, ValidFrom, Quantity }) {
		var quantity = (Side == 'P') ? 2 : 1;
		// If there is a quantity already set (ie: when restoring items from GetJob) then use that instead
		if (Quantity) {
			quantity = Quantity;
		}
		state.items.push({
			Product,
			Description,
			Brand,
			Additional,
			Price,
			Cost,
			DiscountValue,
			DiscountType,
			Side,
			Category,
			SubCategory,
			LeadTime,
			ValidFrom,
			Quantity: quantity
		})
	},
	pullProductFromCart (state, id) {
		state.items.splice(id, 1)
	},
	incrementItemQuantity (state, id) {
		const thisItem = state.items.find(item => item.Product === id)
		if (thisItem.Side == 'P') {
			thisItem.Quantity += 2
		} else {
			thisItem.Quantity++
		}
	},
	setOverrideTotal (state, value) {
		state.override = value*100
	},
	// For use when restoring an override total from DB (no point converting int to currency and back again!)
	setOverrideTotalInteger (state, value) {
		state.override = value
	},
	unsetOverrideTotal (state) {
		state.override = null
	},
	setCartItems (state, { items }) {
		state.items = items
	}
}

export default {
	namespaced: false,
	state,
	getters,
	actions,
	mutations
}
